/**
 * License Renewal.
 *
 *
 * @beta
 */
export const LICENSE_RENEWAL = 'license-renewal'
